import MetaTags from "components/MetaTags";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

const ProductMetaTags = ({ product, presenter }) => {
  if (!product) return null;

  return (
    <MetaTags>
      <meta name="keywords" content={presenter.keywords(product)} />
      <meta name="description" content={presenter.description(product)} />
      <meta name="og:title" content={presenter.mainTitle(product)} />
      <meta name="og:image" content={presenter.metaImage(product)} />
      <meta name="og:image:alt" content={presenter.mainTitle(product)} />
      <meta name="og:description" content={presenter.description(product)} />
      <meta name="fomo:image_url" content={presenter.metaFomoImage(product)} />
    </MetaTags>
  );
};

ProductMetaTags.propTypes = {
  product: TemplateGroupPresenter.shape(),
  presenter: TemplateGroupPresenter.shape(),
};

export default ProductMetaTags;
